import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-pos-order-modal",
  templateUrl: "./pos-order-modal.component.html",
  styleUrls: ["./pos-order-modal.component.css"],
})
export class PosOrderModalComponent implements OnInit {
  @Input() title: string = "Order Action";
  @Input() actionType: string = "";
  @Input() requiresReason: boolean = false;
  @Input() order: any;

  reason: string = "";

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {}

  confirm(): void {
    if (this.requiresReason && !this.reason.trim()) {
      return;
    }
    this.activeModal.close(this.requiresReason ? this.reason : true);
  }

  dismiss(): void {
    this.activeModal.dismiss();
  }

  getActionDisplayText(): string {
    const displayMap: { [key: string]: string } = {
      accept: "accept",
      "ready for pickup": "mark as ready for pickup",
      complete: "complete",
      cancel: "cancel",
    };
    return displayMap[this.actionType.toLowerCase()] || this.actionType;
  }
}
